import { Typography } from '@material-ui/core'
import RoomIcon from '@material-ui/icons/Room'
import { FC } from 'react'

import { DestinationAutoComplete } from '../../components/DestinationAutoComplete'
import { getTranslate } from '../../localization'
import { DestinationOption } from '../../types/accommodationsSubscribedToChannel'
import { SearchAvailabilityInput } from '../../types/searchAvailability'
import useStyles from './styles/SearchWidgetSearchInput.styles'

interface SearchWidgetSearchInputProps {
  options: DestinationOption[]
  setSearchAvailabilityInput: React.Dispatch<
    React.SetStateAction<SearchAvailabilityInput>
  >
  searchAvailabilityInput: SearchAvailabilityInput
  setBookingRedirect: React.Dispatch<React.SetStateAction<string>>
  loadingForWBSData: boolean
}
const SearchWidgetSearchInput: FC<SearchWidgetSearchInputProps> = ({
  options,
  setSearchAvailabilityInput,
  loadingForWBSData,
  searchAvailabilityInput,
  setBookingRedirect
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.destinationHeader}>
        <RoomIcon className={classes.icon} />
        <Typography variant="h6" className={classes.title}>
          {getTranslate('Destination')}
        </Typography>
      </div>
      <div className={classes.destinationAutoComplete}>
        <DestinationAutoComplete
          options={options}
          searchAvailabilityInput={searchAvailabilityInput}
          setSearchAvailabilityInput={setSearchAvailabilityInput!}
          loadingForWBSData={loadingForWBSData}
          setBookingRedirect={setBookingRedirect}
        />
      </div>
    </div>
  )
}
export default SearchWidgetSearchInput
